<template>
  <div>
    <SetPopup ref="confirm" />
    <h3 class="mb-2">샘플 마스터 등록</h3>
    <v-form lazy-validation ref="form">
      <div class="filter-box filter-box--row">
        <ul class="filter-list04">
          <li>
            <h4>*마스터 복사</h4>
            <div class="wrapper">
              <v-text-field v-model="input.code_grade" outlined dense placeholder="" :rules="[this.validSet.empty(input.code_grade, 'Code Grade를 입력해주세요')]"></v-text-field>
              <v-btn style="height: 40px" depressed color="primary" class="ml-2" @click="search">불러오기</v-btn>
            </div>
          </li>
        </ul>
      </div>
    </v-form>
    <h3 class="mt-4 mb-2 dp--row">기본 정보</h3>
    <div class="filter-box filter-box--row">
      <ul class="filter-list">
        <li>
          <h4>w/w</h4>
          <div class="wrapper">
            <v-select v-model="param.ww" outlined dense no-outline hide-details :items="options"></v-select>
          </div>
        </li>
        <li style="width: 400px">
          <h4>품명</h4>
          <div class="wrapper">
            <v-text-field v-model="param.code_title" outlined dense placeholder=""></v-text-field>
          </div>
        </li>
        <li>
          <h4>양산자재 코드</h4>
          <v-text-field v-model="param.mass_code" outlined dense placeholder="" :rules="[this.validSet.commonCodeHipen]"></v-text-field>
        </li>
        <li>
          <h4>제품자재 코드</h4>
          <v-text-field v-model="param.product_code" outlined dense placeholder="" :rules="[this.validSet.commonCodeHipen]"></v-text-field>
        </li>
        <li>
          <h4>Non-PFE 코드</h4>
          <v-text-field v-model="param.non_pfe_code" outlined dense placeholder="" :rules="[this.validSet.commonCodeHipen]"></v-text-field>
        </li>
      </ul>
    </div>
    <h3 class="mt-4 mb-2 dp--row">조성</h3>
    <RealGrid class="sample_grid" domName="settings_sample_add_div1" ref="sample_grid_div1" :settings="settings_div1" :nonePage="true" />
    <RealGrid class="sample_grid" domName="settings_sample_add_div2" ref="sample_grid_div2" :settings="settings_div2" :nonePage="true" />
    <RealGrid class="sample_grid" domName="settings_sample_add_div3" ref="sample_grid_div3" :settings="settings_div3_noSum" :nonePage="true" />
    <h3 class="mt-4 mb-2 dp--row">실제조성</h3>
    <RealGrid class="real_grid" domName="settings_real_add_div1" ref="real_grid_div1" :settings="settings_div1" :nonePage="true" @changeData="changeDataReal" @edit-row-pasted="onEditRowPasted" />
    <RealGrid class="real_grid" domName="settings_real_add_div2" ref="real_grid_div2" :settings="settings_div2" :nonePage="true" @changeData="changeDataReal" @edit-row-pasted="onEditRowPasted" />
    <RealGrid class="real_grid" domName="settings_real_add_div3" ref="real_grid_div3" :settings="settings_div3" :nonePage="true" @changeData="changeDataReal" @edit-row-pasted="onEditRowPasted" />
    <h3 class="mt-4 mb-2 dp--row">제조조성</h3>
    <RealGrid class="make_grid" domName="settings_make_add_div1" ref="make_grid_div1" :settings="settings_div1" :nonePage="true" @changeData="changeDataMake" />
    <RealGrid class="make_grid" domName="settings_make_add_div2" ref="make_grid_div2" :settings="settings_div2" :nonePage="true" @changeData="changeDataMake" />
    <RealGrid class="make_grid" domName="settings_make_add_div3" ref="make_grid_div3" :settings="settings_div3" :nonePage="true" @changeData="changeDataMake" />
    <h3 class="mt-2 dp--row">세부스팩</h3>
    <RealGrid domName="settings_real_spec_add" ref="real_spec_grid" :settings="real_settings_spec" :nonePage="true" :style="realSpecCheck ? '' : 'display: none'" />
    <h3 class="mt-2 dp--row">
      실험스팩
      <div class="mb-2 dp--row btn-box">
        <v-select class="mr-2" dense outlined :items="sampleFormOptions" item-text="text" item-value="value" v-model="selectedSampleForm" style="width: 220px" placeholder="양식선택" @change="onSampleFormChanged" />
        <v-btn depressed class="btn-add" @click="specAdd">추가</v-btn>
        <v-btn depressed class="btn-delete" @click="specDel">삭제</v-btn>
      </div>
    </h3>
    <RealGrid domName="settings_spec" ref="spec_grid" :settings="settings_spec" :nonePage="true" />
    <div class="wrapper mt-4">
      <div class="btn-box">
        <button class="btn-reset" @click="reset">초기화</button>
        <button class="btn-search" @click="save">저장</button>
      </div>
    </div>
  </div>
</template>
<script>
import { insertSampleMaster, sampleMasterDetail } from 'api/sample/sample';
import { makeSum, makeARow, makeSampleSet, setNewSum } from '@/assets/grid/gridUtill';
import SetPopup from '@/components/SetPopup.vue';
import _ from 'lodash';
import * as sample1 from '@/assets/grid/sampleRequestDiv1';
import * as sample2 from '@/assets/grid/sampleRequestDiv2';
import * as sample3 from '@/assets/grid/sampleRequestDiv3';
import * as spec from '@/assets/grid/spec';
import * as spec2 from '@/assets/grid/spec2';
import RealGrid from '@/components/RealGrid.vue';
import { mapMutations } from 'vuex';
import validSet from '@/assets/valid';
import { parseSampleApiBusinessError, sampleApiBusinessErrorText } from '@/utils/sampleApiError';
export default {
  data() {
    return {
      id: '',
      validSet,
      realSpecCheck: false,
      realSpecGridHeight: 150,
      input: {
        code_grade: '',
      },
      param: {
        code_title: '',
        code_grade: '',
        ww: 0,
        mass_code: '',
        product_code: '',
        non_pfe_code: '',
      },
      key: {
        solvent1: 'solventVol1',
        solvent2: 'solventVol2',
        solvent3: 'solventVol3',
        solvent4: 'solventVol4',
        solvent5: 'solventVol5',
        solvent6: 'solventVol6',
        solvent7: 'solventVol7',
        solvent8: 'solventVol8',
        solvent9: 'solventVol9',
        solvent10: 'solventVol10',
        salt1: 'saltVol1',
        salt2: 'saltVol2',
        salt3: 'saltVol3',
        add1: 'addVol1',
        add2: 'addVol2',
        add3: 'addVol3',
        add4: 'addVol4',
        add5: 'addVol5',
        add6: 'addVol6',
        add7: 'addVol7',
        add8: 'addVol8',
        add9: 'addVol9',
        add10: 'addVol10',
      },
      grid: 'sampleMasterAdd',
      settings_div1: this.gridSetting(sample1, false),
      settings_div2: this.gridSetting(sample2, false),
      settings_div3: this.gridSetting(sample3, false),
      settings_div3_noSum: this.gridSetting(sample3, true),
      settings_spec: this.gridSetting(spec, false, 700, false),
      options: [
        { text: 'Y', value: 1 },
        { text: 'N', value: 0 },
      ],
      sampleFormOptions: [
        { text: '양식선택', value: '' },
        { text: '삼성', value: '삼성' },
        { text: '일반', value: '일반' },
        { text: 'SK온', value: 'SK온' },
        { text: '현대자동차', value: '현대자동차' },
        { text: 'LG엔솔 (ESA 미포함)', value: 'LG엔솔 (ESA 미포함)' },
        { text: 'LG엔솔 (ESA 포함)', value: 'LG엔솔 (ESA 포함)' },
      ],
      selectedSampleForm: '',
    };
  },
  computed: {
    real_settings_spec() {
      return {
        ...spec,
        columns: _.map(_.cloneDeep(spec2.columns), function (v) {
          if (v.name == 'low1' || v.name == 'hig1' || v.name == 'mid1') {
            v.editable = true;
          }
          return v;
        }),
        hideCheckBar: true,
        noneNo: true,
        height: this.realSpecGridHeight,
      };
    },
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    this.setGrid();
  },
  methods: {
    ...mapMutations('menu', ['REMOVE_SELECT_MENU', 'SET_SELECT_MENU_TAB_BY_CODE']),
    ...mapMutations('popup', ['SET_POPUP']),
    ...mapMutations('member', ['SET_USER_INFO']),
    valid() {
      return this.$refs.form.validate();
    },
    gridSetting(sample, existSum, height, hideCheckBar) {
      return {
        ...sample,
        columns: existSum
          ? _.map(
              _.filter(_.cloneDeep(sample3.columns), v => v.fieldName !== 'sum'),
              function (v) {
                v.editable = true;
                return v;
              },
            )
          : _.map(_.cloneDeep(sample.columns), function (v) {
              v.editable = true;
              return v;
            }),
        hideCheckBar: hideCheckBar === false ? hideCheckBar : true,
        height: height ? height : 150,
        noneNo: true,
      };
    },
    openPopup(text, closable, cb) {
      this.SET_POPUP({
        title: '알림',
        // height: 150,
        width: 300,
        closable,
        text,
      });
      this.$refs.confirm.openPopup(cb);
    },
    newSample() {
      this.$emit('newSample');
    },
    setNewSum(ref) {
      let tmp = {};
      for (let i = 1; i <= 3; i++) {
        tmp = { ...tmp, ...this.$refs[ref + i].getJsonRow() };
      }
      const sum = [setNewSum(tmp)];
      this.$refs[ref + 3].loadData(sum);
    },
    changeDataReal() {
      // 실제조성 그리드의 데이터를 세부스팩으로 자동 반영
      const row1 = this.$refs.real_grid_div1.getJsonRow();
      const row2 = this.$refs.real_grid_div2.getJsonRow();
      const row3 = this.$refs.real_grid_div3.getJsonRow();
      const row = { ...row1, ...row2, ...row3 };
      const key = _.without(_.keys(row), 'ww', 'lotNo', 'sum');
      const rowArr = [];
      let unit = '';
      let vol = '';

      _.each(key, v => {
        if (!v.includes('Vol')) {
          unit = 'wt%';
          vol = Number(row[this.key[v]]);
          if (isNaN(vol)) {
            vol = '';
          }
          const spec = row[v];
          if (!_.isEmpty(spec)) {
            let specData = { low: 0, mid: 0, hig: 0 };

            // vol 값이 있으면 항상 자동 계산
            if (!isNaN(vol) && vol !== '') {
              let low, mid, high;
              mid = Math.round(vol * 100) / 100;

              if (v.includes('solvent')) {
                if (vol < 10) {
                  const addValue = vol * 0.1;
                  low = Math.round((vol - addValue) * 100) / 100;
                  high = Math.round((vol + addValue) * 100) / 100;
                } else {
                  low = Math.round((vol - 1) * 100) / 100;
                  high = Math.round((vol + 1) * 100) / 100;
                }
              } else if (v.includes('salt')) {
                low = Math.round((vol - 0.5) * 100) / 100;
                high = Math.round((vol + 0.5) * 100) / 100;
              } else if (v.includes('add')) {
                const addValue = vol * 0.1;
                low = Math.round((vol - addValue) * 100) / 100;
                high = Math.round((vol + addValue) * 100) / 100;
              }

              specData = { low, mid, hig: high };
            }

            rowArr.push({ spec, unit, vol, ...specData });
          }
        }
      });

      if (rowArr.length > 0) {
        this.$refs.real_spec_grid.loadData(rowArr);
        this.realSpecCheck = true;
        // 그리드 높이 동적 계산: 헤더(40px) + 행 높이(32px * 행 수) + 여유(10px)
        const rowHeight = 32;
        const headerHeight = 40;
        const padding = 10;
        this.realSpecGridHeight = Math.max(100, headerHeight + rowArr.length * rowHeight + padding);
      } else {
        this.realSpecCheck = false;
        this.realSpecGridHeight = 150;
      }

      this.setNewSum('real_grid_div');
    },
    changeDataMake() {
      this.setNewSum('make_grid_div');
    },
    onEditRowPasted({ grid, itemIndex, newValues }) {
      // 붙여넣은 값들을 그리드에 반영
      for (let i = 0; i < newValues.length; i++) {
        if (newValues[i] !== undefined) {
          grid.setValue(itemIndex, i, newValues[i]);
        }
      }

      // 그리드 갱신 후 세부스팩 업데이트
      this.$nextTick(() => {
        this.changeDataReal();
      });
    },
    onSampleFormChanged() {
      // 변경 시 기존 데이터 제거
      try {
        if (this.$refs.spec_grid && typeof this.$refs.spec_grid.loadData === 'function') {
          this.$refs.spec_grid.loadData([]);
        }
      } catch (_) {}

      // 값이 비었으면 종료
      if (!this.selectedSampleForm) {
        return;
      }

      // 드롭다운 변경 시 프리셋 적용
      if (this.selectedSampleForm === '삼성') {
        const preset = [
          { spec: 'Moisture', unit: 'ppm', vol: '15' },
          { spec: 'Acid (as HF)', unit: 'ppm', vol: '50' },
          { spec: 'Cl', unit: 'ppm', vol: '1.5' },
          { spec: 'SO4-', unit: 'ppm', vol: '1.5' },
          { spec: 'Na', unit: 'ppm', vol: '1.5' },
          { spec: 'K', unit: 'ppm', vol: '1.5' },
          { spec: 'Ca', unit: 'ppm', vol: '1.5' },
          { spec: 'Fe', unit: 'ppm', vol: '1.5' },
          { spec: 'Al', unit: 'ppm', vol: '3' },
          { spec: 'Cu', unit: 'ppm', vol: '1.5' },
          { spec: 'Cr', unit: 'ppm', vol: '1.5' },
          { spec: 'Zn', unit: 'ppm', vol: '1.5' },
          { spec: 'Color', unit: 'APHA', vol: '100' },
          { spec: 'Density (25℃)', unit: 'g/cm3', vol: '0' },
          { spec: 'Conductivity (25℃)', unit: 'mS/cm', vol: '0' },
          { spec: 'Viscosity (25℃)', unit: 'cP', vol: '0' },
        ];
        this.addPresetRows(preset);
      }

      // 일반 프리셋
      if (this.selectedSampleForm === '일반') {
        const preset = [
          { spec: 'Moisture', unit: 'ppm', vol: '20' },
          { spec: 'HF', unit: 'ppm', vol: '80' },
          { spec: 'Cl', unit: 'ppm', vol: '5' },
          { spec: 'SO4', unit: 'ppm', vol: '10' },
          { spec: 'Na', unit: 'ppm', vol: '3' },
          { spec: 'K', unit: 'ppm', vol: '3' },
          { spec: 'Ca', unit: 'ppm', vol: '3' },
          { spec: 'Fe', unit: 'ppm', vol: '3' },
          { spec: 'Al', unit: 'ppm', vol: '3' },
          { spec: 'Cu', unit: 'ppm', vol: '3' },
          { spec: 'Cr', unit: 'ppm', vol: '3' },
          { spec: 'Zn', unit: 'ppm', vol: '3' },
          { spec: 'Color', unit: 'APHA', vol: '100' },
          { spec: 'Density', unit: 'g/cm3', vol: '0' },
        ];
        this.addPresetRows(preset);
      }

      // SK온 프리셋
      if (this.selectedSampleForm === 'SK온') {
        const preset = [
          { spec: 'Moisture', unit: 'ppm', vol: '20' },
          { spec: 'HF', unit: 'ppm', vol: '70' },
          { spec: 'CI', unit: 'ppm', vol: '5' },
          { spec: 'SO4', unit: 'ppm', vol: '10' },
          { spec: 'Na', unit: 'ppm', vol: '5' },
          { spec: 'K', unit: 'ppm', vol: '5' },
          { spec: 'Ca', unit: 'ppm', vol: '5' },
          { spec: 'Fe', unit: 'ppm', vol: '5' },
          { spec: 'Pb', unit: 'ppm', vol: '5' },
          { spec: 'Color', unit: 'APHA', vol: '100' },
          { spec: 'Density (25℃)', unit: 'g/cm3', vol: '0' },
          { spec: 'Conductivity (25℃)', unit: 'mS/cm', vol: '0' },
          { spec: 'Viscosity (25℃)', unit: 'cP', vol: '0' },
        ];
        this.addPresetRows(preset);
      }

      // 현대자동차 프리셋
      if (this.selectedSampleForm === '현대자동차') {
        const preset = [
          { spec: 'Moisture', unit: 'ppm', vol: '20' },
          { spec: 'HF', unit: 'ppm', vol: '80' },
          { spec: 'CI', unit: 'ppm', vol: '5' },
          { spec: 'SO4', unit: 'ppm', vol: '10' },
          { spec: 'Na', unit: 'ppm', vol: '5' },
          { spec: 'K', unit: 'ppm', vol: '5' },
          { spec: 'Ca', unit: 'ppm', vol: '5' },
          { spec: 'Fe', unit: 'ppm', vol: '5' },
          { spec: 'Pb', unit: 'ppm', vol: '5' },
          { spec: 'Color', unit: 'APHA', vol: '100' },
          { spec: 'Density (25℃)', unit: 'g/cm3', vol: '0' },
        ];
        this.addPresetRows(preset);
      }

      // LG엔솔 (ESA 미포함) 프리셋
      if (this.selectedSampleForm === 'LG엔솔 (ESA 미포함)') {
        const preset = [
          { spec: 'Moisture', unit: 'ppm', vol: '15' },
          { spec: 'Acid (as HF)', unit: 'ppm', vol: '75' },
          { spec: 'Cl', unit: 'ppm', vol: '5' },
          { spec: 'SO4-', unit: 'ppm', vol: '5' },
          { spec: 'Na', unit: 'ppm', vol: '1' },
          { spec: 'K', unit: 'ppm', vol: '1' },
          { spec: 'Ca', unit: 'ppm', vol: '1' },
          { spec: 'Fe', unit: 'ppm', vol: '1' },
          { spec: 'Cu', unit: 'ppm', vol: '1' },
          { spec: 'Cr', unit: 'ppm', vol: '1' },
          { spec: 'Ni', unit: 'ppm', vol: '1' },
          { spec: 'Pb', unit: 'ppm', vol: '1' },
          { spec: 'Color', unit: 'APHA', vol: '150' },
          { spec: 'Density (25℃)', unit: 'g/cm3', vol: '0' },
          { spec: 'Conductivity (25℃)', unit: 'mS/cm', vol: '0' },
          { spec: 'Viscosity (25℃)', unit: 'cP', vol: '0' },
        ];
        this.addPresetRows(preset);
      }

      // LG엔솔 (ESA 포함) 프리셋
      if (this.selectedSampleForm === 'LG엔솔 (ESA 포함)') {
        const preset = [
          { spec: 'Moisture', unit: 'ppm', vol: '15' },
          { spec: 'Acid (as HF)', unit: 'ppm', vol: '120' },
          { spec: 'Cl', unit: 'ppm', vol: '5' },
          { spec: 'SO4-', unit: 'ppm', vol: '5' },
          { spec: 'Na', unit: 'ppm', vol: '1' },
          { spec: 'K', unit: 'ppm', vol: '1' },
          { spec: 'Ca', unit: 'ppm', vol: '1' },
          { spec: 'Fe', unit: 'ppm', vol: '1' },
          { spec: 'Cu', unit: 'ppm', vol: '1' },
          { spec: 'Cr', unit: 'ppm', vol: '1' },
          { spec: 'Ni', unit: 'ppm', vol: '1' },
          { spec: 'Pb', unit: 'ppm', vol: '1' },
          { spec: 'Color', unit: 'APHA', vol: '150' },
          { spec: 'Density (25℃)', unit: 'g/cm3', vol: '0' },
          { spec: 'Conductivity (25℃)', unit: 'mS/cm', vol: '0' },
          { spec: 'Viscosity (25℃)', unit: 'cP', vol: '0' },
        ];
        this.addPresetRows(preset);
      }
    },
    addPresetRows(preset) {
      try {
        const rowTemplate = makeARow(spec.fields)[0] || {};
        const adds = preset.map(p => ({
          ...rowTemplate,
          spec: p.spec,
          unit: p.unit,
          vol: p.vol,
          low: '0',
          mid: '0',
          hig: p.vol,
        }));
        this.$refs.spec_grid.loadData(adds);
      } catch (_) {}
    },
    addSpec(ref) {
      const row = this.$refs[ref].getJsonRow();
      const key = _.keys(row);
      const beforeSpec = this.$refs.spec_grid.getJsonRows();
      const fixSpec = beforeSpec.slice(-11);
      // const rowtmp = makeARow(spec.fields)[0];
      const rowArr = [];
      let unit = '';
      let vol = '';
      _.each(key, v => {
        if (!v.includes('Vol')) {
          if (v.includes('solvent')) {
            unit = 'vol';
            vol = Number(row[this.key[v]]);
          } else if (v.includes('salt')) {
            unit = 'M.wt%';
          } else if (v.includes('add')) {
            unit = 'wt%';
          }
          const spec = row[v];
          if (!_.isEmpty(spec)) {
            rowArr.push({ spec, unit, vol, low: 0, mid: 0, hig: 0 });
          }
        }
      });
      this.$refs.spec_grid.loadData(rowArr.concat(fixSpec));
    },
    setGrid() {
      const gridKey = ['sample_grid_div', 'real_grid_div', 'make_grid_div'];
      const sampleKey = [sample1.fields, sample2.fields, sample3.fields];
      this.setGridExec(gridKey, sampleKey);
      this.$refs.spec_grid.loadData([]);
      this.$refs.real_spec_grid.loadData([]);
    },
    setGridExec(g, s) {
      _.each(g, v => {
        for (let i = 1; i <= 3; i++) {
          this.$refs[v + i].loadData(makeARow(s[i - 1]));
        }
      });
    },
    setGridExecSearch(g, s) {
      _.each(g, v => {
        for (let i = 1; i <= 3; i++) {
          this.$refs[v + i].loadData([s[v]]);
        }
      });
    },
    search() {
      if (this.valid()) {
        sampleMasterDetail(this.input.code_grade)
          .then(res => {
            const code = this.input.code_grade;
            const response = res.data.data;
            const CodeDB = response.CodeDB;
            const CodeDB_A = response.CodeDB_A;
            const CodeDB_B = response.CodeDB_B;
            const CodeDB_Dt = response.CodeDB_Dt;
            let subCodeDB_Dt = response.subCodeDB_Dt;

            const gridKey = ['sample_grid_div', 'real_grid_div', 'make_grid_div'];
            const sampleKey = {
              sample_grid_div: { ...CodeDB, code },
              real_grid_div: { ...makeSum(CodeDB_A), code },
              make_grid_div: { ...makeSum(CodeDB_B), code },
            };
            this.setGridExecSearch(gridKey, sampleKey);

            // 세부스팩 데이터 로드
            if (subCodeDB_Dt?.length > 0) {
              subCodeDB_Dt = subCodeDB_Dt.map(item => ({
                ...item,
                hig: item.hig === null || '' ? 0 : item.hig,
                low: item.low === null || '' ? 0 : item.low,
                mid: item.mid === null || '' ? 0 : item.mid,
                rv: item.rv === null || '' ? 0 : item.rv,
              }));
              this.$refs.real_spec_grid.loadData(subCodeDB_Dt);
              this.realSpecCheck = true;
              // 그리드 높이 동적 계산
              const rowHeight = 32;
              const headerHeight = 40;
              const padding = 10;
              this.realSpecGridHeight = Math.max(100, headerHeight + subCodeDB_Dt.length * rowHeight + padding);
            } else {
              this.$refs.real_spec_grid.loadData([]);
              this.realSpecCheck = false;
              this.realSpecGridHeight = 150;
            }

            // 실험스팩 데이터 로드
            this.$refs.spec_grid.loadData(CodeDB_Dt);

            this.param.code_grade = code;
            this.param.code_title = CodeDB.code_title;
            this.param.ww = CodeDB.ww;
            this.param.mass_code = CodeDB.mass_code;
            this.param.product_code = CodeDB.product_code;
            this.param.non_pfe_code = CodeDB.non_pfe_code;
          })
          .catch(res => {
            console.error(res);
          });
      }
    },
    reset() {
      this.param = {
        code_title: '',
        code_grade: '',
        ww: 0,
        mass_code: '',
        product_code: '',
        non_pfe_code: '',
      };
      this.input = {
        code_grade: '',
      };
      this.selectedSampleForm = '';
      this.realSpecCheck = false;
      this.realSpecGridHeight = 150;
      this.setGrid();
    },
    specAdd() {
      const row = this.$refs.spec_grid.getJsonRows();
      const add = makeARow(spec.fields);
      this.$refs.spec_grid.loadData(row.concat(add));
    },
    specDel() {
      const row = this.$refs.spec_grid.getJsonRows();
      const idx = this.$refs.spec_grid.getCheckedRowIdx();
      if (idx.length < 1) {
        this.openPopup('삭제할 행을 선택해주세요');
      } else {
        this.openPopup('삭제하시겠습니까', true, () => {
          const ret = _.filter(row, (v, index) => {
            return !idx.includes(index);
          });
          this.$refs.spec_grid.loadData(ret);
        });
      }
    },
    save() {
      const sum1 = this.$refs.real_grid_div3.getJsonRow().sum;
      const sum2 = this.$refs.make_grid_div3.getJsonRow().sum;
      if (sum1 > 100 || sum2 > 100) {
        this.openPopup('SUM 정보를 확인해 주세요');
      } else {
        const sample = {
          ...this.$refs.sample_grid_div1.getJsonRow(),
          ...this.$refs.sample_grid_div2.getJsonRow(),
          ...this.$refs.sample_grid_div3.getJsonRow(),
          ww: this.param.ww,
          code_title: this.param.code_title,
          mass_code: this.param.mass_code,
          product_code: this.param.product_code,
          non_pfe_code: this.param.non_pfe_code,
          memberId: this.id,
        };
        const sampleA = {
          ...this.$refs.real_grid_div1.getJsonRow(),
          ...this.$refs.real_grid_div2.getJsonRow(),
          ...this.$refs.real_grid_div3.getJsonRow(),
          memberId: this.id,
        };
        const sampleB = {
          ...this.$refs.make_grid_div1.getJsonRow(),
          ...this.$refs.make_grid_div2.getJsonRow(),
          ...this.$refs.make_grid_div3.getJsonRow(),
          memberId: this.id,
        };

        // 실험스팩 데이터 (spec_grid)
        let dt = this.$refs.spec_grid.getJsonAllRow();
        dt = dt.filter(item => item[0]); // spec명 없는경우 삭제
        const sampleDetail = makeSampleSet(dt, null, this.id);

        // 세부스팩 데이터 (real_spec_grid)
        const dt2 = this.$refs.real_spec_grid.getJsonAllRow();
        const sampleDetail2 = makeSampleSet(dt2, null, this.id);

        // 중복 스펙명 확인
        let dtSpecNames = dt.map(row => row[0]);
        let dt2SpecNames = dt2.map(row => row[0]);
        let duplicateFound = dtSpecNames.some(specName => dt2SpecNames.includes(specName));

        if (duplicateFound) {
          this.openPopup('중복된 스펙이 있습니다');
        } else {
          this.openPopup('저장 하시겠습니까?', true, () => {
            insertSampleMaster({
              sample,
              sampleA,
              sampleB,
              sampleDetail,
              sampleDetail2,
            })
              .then(res => {
                const parsed = parseSampleApiBusinessError(res);
                if (parsed.hasBusinessError) {
                  this.openPopup(sampleApiBusinessErrorText(parsed), false);
                  return;
                }
                this.openPopup('저장되었습니다', false);

                this.REMOVE_SELECT_MENU('sampleAdd');
                this.SET_SELECT_MENU_TAB_BY_CODE('SPMGMT');
                this.$emit('save');
              })
              .catch(() => {
                const errorMsg = '내부 서버 오류가 발생했습니다. 관리자에게 문의해주세요.';
                this.openPopup(errorMsg, false);
              });
          });
        }
      }
    },
  },
  components: {
    RealGrid,
    SetPopup,
  },
};
</script>
<style lang="scss" scope>
.sample_grid {
  margin-bottom: 10px !important;
  .rg-header {
    background-color: #edf1d6;
  }
}
.real_grid {
  margin-bottom: 10px !important;
  .rg-header {
    background-color: #e1eedd;
  }
}
.make_grid {
  margin-bottom: 10px !important;
  .rg-header {
    background-color: #9dc08b;
  }
}
</style>
